import {
    NOTIFICATION_LOCAL,
    NOTIFICATION_COMMENT_LOCAL,
    NOTIFICATION_SOCKET,
    DAY_OFF_SOCKET, TASK_SOCKET, NOTIFY_FAIL, NOTIFY_REQUEST, NOTIFY_SUCCESS
} from "../actions/notification.js";


const initialState = {
    notification: [], page: 1, comment: {notification_comment: []},
    taskSocket: 'off',
    dayoffSocketSetter: 'off',
    notificationSocketSetter: 'off',
    notifyData: [],
    notifyDataStatus: 'request',
};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {

        case NOTIFICATION_LOCAL: {
            return {
                ...state,
                notification: action.payload.form,
                page: action.payload.page
            };
        }
        case NOTIFICATION_COMMENT_LOCAL: {
            return {
                ...state,
                comment: action.payload.form,

            };
        }
        case NOTIFICATION_SOCKET: {
            return {
                ...state,
                notificationSocketSetter: action.payload.status,
            };
        }
        case DAY_OFF_SOCKET: {
            return {
                ...state,
                dayoffSocketSetter: action.payload.status,

            };
        }
        case TASK_SOCKET: {
            return {
                ...state,
                taskSocket: action.payload.status,

            };
        }
        case NOTIFY_REQUEST: {
            return {
                ...state,
                notifyDataStatus: 'request',

            };
        }
        case NOTIFY_SUCCESS: {
            return {
                ...state,
                notifyDataStatus: 'ok',
                notifyData: action.payload.data,
            };
        }
        case NOTIFY_FAIL: {
            return {
                ...state,
                notifyDataStatus: 'fail',

            };
        }

        default: {
            return {
                ...state,
            };
        }
    }
}
